var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete, Avatar, Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreateTeamPlayerInvitation, useSearchInvitablePlayers, } from "../api/InvitationApiProvider";
import { useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ROUTES } from "../breadcrumbs/routeConfig";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useDebounce } from "../utils/useDebounce";
import { useNumericParams } from "../utils/useNumericParams";
export var SendInvitation = function () {
    var teamId = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrieveUserTeamPermissions({ teamId: teamId }), permissions = _a.data, isPermLoading = _a.isLoading;
    var canModify = (permissions === null || permissions === void 0 ? void 0 : permissions.canModify) === true;
    var _b = useRetrieveTeam({ id: teamId, enabled: canModify }), team = _b.data, isTeamLoading = _b.isLoading, teamError = _b.error;
    var _c = useRetrievePlayersByTeamId({ teamId: teamId }), players = _c.data, isPlayersLoading = _c.isLoading, playersError = _c.error;
    var _d = __read(useState(""), 2), errorMessage = _d[0], setErrorMessage = _d[1];
    var _f = __read(useState(""), 2), searchTerm = _f[0], setSearchTerm = _f[1];
    var debouncedSearchTerm = useDebounce(searchTerm, 300);
    var _g = useSearchInvitablePlayers({
        teamId: teamId,
        searchTerm: debouncedSearchTerm || undefined,
    }), searchResults = _g.data, isSearchFetching = _g.isFetching;
    var isSearchLoading = isSearchFetching;
    var _h = useForm({
        defaultValues: {
            invitee: null,
            email: "",
            mergePlayer: null,
            message: "",
        },
    }), control = _h.control, handleSubmit = _h.handleSubmit, setValue = _h.setValue, watch = _h.watch, errors = _h.formState.errors;
    var selectedInvitee = watch("invitee");
    var createMutation = useCreateTeamPlayerInvitation({
        teamId: teamId,
        onMutate: function () { },
        onSuccess: function () {
            return navigate(ROUTES.TEAM_INVITATIONS.replace(":id", String(teamId)));
        },
        onError: function (error) {
            var _a;
            var data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
            if (data) {
                var messages = Object.values(data).flat();
                setErrorMessage(messages.join(" "));
            }
            else {
                setErrorMessage("Failed to send invitation.");
            }
        },
    });
    var onSubmit = function (data) {
        createMutation.mutate(__assign(__assign(__assign(__assign({}, (data.invitee ? { invitee: data.invitee } : {})), (data.email ? { email: data.email } : {})), (data.mergePlayer ? { mergePlayer: data.mergePlayer } : {})), (data.message ? { message: data.message } : {})));
    };
    if (isPermLoading || (canModify && (isTeamLoading || isPlayersLoading))) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (teamError || playersError || !team) {
        return _jsx(ErrorView, { error: teamError || playersError });
    }
    var mergeablePlayers = (players || []).filter(function (p) { return p.user === null; });
    var playerOptions = ((searchResults === null || searchResults === void 0 ? void 0 : searchResults.results) || []).map(function (p) { return ({
        id: p.userId,
        label: "".concat(p.firstName, " ").concat(p.lastName),
        picture: p.picture,
    }); });
    return (_jsxs(React.Fragment, { children: [_jsxs(Typography, { variant: "h4", gutterBottom: true, children: ["Send Invitation \u2014 ", team.name] }), _jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, role: "form", sx: { maxWidth: 600, mt: 2 }, children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", sx: { mb: 2 }, children: "Search for a registered user or enter an email address to invite someone." }), _jsx(Controller, { name: "invitee", control: control, rules: {
                            validate: function (value) {
                                var email = watch("email");
                                if (!value && !email) {
                                    return "Please select a user or enter an email address";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(Autocomplete, { options: playerOptions, getOptionLabel: function (option) {
                                    return typeof option === "string" ? option : option.label;
                                }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, filterOptions: function (x) { return x; }, loading: isSearchLoading, onInputChange: function (_e, value) { return setSearchTerm(value); }, onChange: function (_e, value) {
                                    field.onChange(value ? value.id : null);
                                }, renderOption: function (props, option) {
                                    var _a;
                                    return (_createElement(Box, __assign({ component: "li" }, props, { key: option.id, sx: { display: "flex", alignItems: "center", gap: 1 } }),
                                        _jsx(Avatar, { src: (_a = option.picture) !== null && _a !== void 0 ? _a : undefined, sx: { width: 32, height: 32 }, children: option.label.charAt(0) }),
                                        option.label));
                                }, renderInput: function (params) {
                                    var _a;
                                    return (_jsx(TextField, __assign({}, params, { label: "Search for User", margin: "normal", fullWidth: true, error: !!errors.invitee, helperText: (_a = errors.invitee) === null || _a === void 0 ? void 0 : _a.message, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [isSearchLoading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) })));
                                } }));
                        } }), !selectedInvitee && (_jsx(Controller, { name: "email", control: control, rules: {
                            validate: function (value) {
                                var invitee = watch("invitee");
                                if (!invitee && !value) {
                                    return "Please select a user or enter an email address";
                                }
                                if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                    return "Please enter a valid email address";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "Or Enter Email Address", type: "email", error: !!errors.email, helperText: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message })));
                        } })), mergeablePlayers.length > 0 && (_jsxs(FormControl, { fullWidth: true, sx: { mt: 2 }, children: [_jsx(InputLabel, { children: "Merge With Existing Player (Optional)" }), _jsx(Controller, { name: "mergePlayer", control: control, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (_jsx(Select, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", label: "Merge With Existing Player (Optional)", endAdornment: field.value ? (_jsx("div", { onClick: function (e) {
                                                e.stopPropagation();
                                                setValue("mergePlayer", null);
                                            }, style: { marginRight: 20, cursor: "pointer" }, children: _jsx(ClearIcon, { "data-testid": "clear-merge-player" }) })) : undefined, children: mergeablePlayers.map(function (player) {
                                            var _a, _b;
                                            return (_jsxs(MenuItem, { value: player.id, children: [(_a = player.externalUser) === null || _a === void 0 ? void 0 : _a.firstName, " ", (_b = player.externalUser) === null || _b === void 0 ? void 0 : _b.lastName] }, player.id));
                                        }) })));
                                } }), _jsx(Typography, { variant: "caption", color: "text.secondary", sx: { mt: 0.5 }, children: "Optionally merge the invitee with an offline player to combine stats." })] })), _jsx(Controller, { name: "message", control: control, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "Message (Optional)", multiline: true, rows: 3 })));
                        } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", disabled: createMutation.isLoading, sx: { mt: 3, mb: 2 }, children: createMutation.isLoading ? "Sending..." : "Send Invitation" })] }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
